module.exports = __webpack_public_path__ + "static/media/too-much-ink@2x.add3de24.png";